module.exports = "<div id=\"loadessr\" [hidden]=\"!isLoading()\">\n  <div id=\"loader\"></div>\n</div>\n<app-alert-error></app-alert-error>\n<router-outlet></router-outlet>\n\n<ng-template #template>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title pull-left\">Attenzione!</h4>\n  </div>\n  <div class=\"modal-body\">\n    Il browser che stai utilizzando non è supportato da Tesseramento A.S.C,\n    si consiglia di utilizzare le ultime versioni di Chrome o Firefox.\n  </div>\n</ng-template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main